import { render, staticRenderFns } from "./perfect.vue?vue&type=template&id=3b5f3e1e&"
import script from "./perfect.vue?vue&type=script&lang=js&"
export * from "./perfect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports